import { BaseClient, AxiosInstance } from '@core/base/http-client/base-client'
import { envVars } from '@core/environment/env-vars'

type TSDKConstructor<T> = new (
    axiosInstance: AxiosInstance,
    prefix?: string
) => T

type TClientConfig = {
    baseURL?: string
    withCredentials?: boolean
    prefix?: string
}

type TRemoteClient<T> = T

export function createClient<T>(
    sdk: TSDKConstructor<T>,
    config?: TClientConfig
) {
    BaseClient.defaults.baseURL =
        config?.baseURL ?? envVars.REACT_APP_API_BASE_URL
    BaseClient.defaults.withCredentials = config?.withCredentials ?? true

    const prefix = config?.prefix ?? envVars.REACT_APP_API_URL_PREFIX

    const client = new sdk(BaseClient, prefix)

    return client satisfies TRemoteClient<T>
}
